function IconProG() {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.181 20.974c.082-.155.148-.293.224-.424.425-.727.853-1.453 1.278-2.18.316-.54.63-1.08.944-1.622l.944-1.621c.203-.35.401-.701.605-1.05a.283.283 0 00.001-.312c-.316-.54-.629-1.08-.943-1.622l-1.459-2.508-.881-1.524-.985-1.698-.918-1.587c-.032-.056-.054-.118-.09-.197.082-.005.14-.01.196-.01 1.814-.002 3.629.002 5.443-.009.251-.001.39.102.485.309.04.087.085.172.134.254.255.431.514.86.767 1.292.32.544.635 1.09.95 1.635l.927 1.599.964 1.66.919 1.585c.155.266.308.533.464.798a.346.346 0 01-.002.381c-.257.43-.513.86-.767 1.292-.338.576-.675 1.154-1.012 1.732l-.885 1.52c-.33.566-.662 1.13-.99 1.695a7.497 7.497 0 00-.194.355c-.097.19-.253.26-.465.258-.712-.006-1.424-.003-2.137-.003l-3.35.001h-.167z"
        fill="#E3ECF1"
      />
      <path
        d="M6.549 13.95h8.908c-.022.052-.034.092-.054.128-.11.197-.222.394-.336.589-.407.693-.816 1.385-1.222 2.078-.302.515-.6 1.031-.901 1.546l-.967 1.658-.877 1.51c-.347.6-.695 1.2-1.038 1.8-.059.103-.143.12-.245.12l-1.624.003-4.053.002h-.19c.026-.053.038-.083.055-.11.251-.41.51-.818.754-1.232.496-.836.985-1.675 1.476-2.514.309-.527.616-1.055.922-1.584.355-.612.706-1.225 1.061-1.837.05-.087.05-.162-.015-.237l-.694-.797c-.276-.316-.553-.632-.828-.95-.04-.046-.075-.098-.131-.174h-.001z"
        fill="#E3ECF1"
      />
    </svg>
  );
}

export default IconProG
